import Vue from 'vue';
import Vuex from 'vuex';

import state from '@/store/rootState';
import getters from '@/store/rootGetters';
import mutations from '@/store/rootMutations';
import actions from '@/store/rootActions';

import modal from '@/store/modules/modal/modal.js';
import products from "@/store/modules/products/products";


Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    getters,
    mutations,
    actions,
    modules: {
        modal,
        products
    },
});
